<div class="flex-header mat-dialog-title" translate>
  Welcome!
</div>
<div class="flex-content">
  <div class="robotoMedium" translate>
    Here are a couple of things to help get you started.
  </div>
  <ol type="1" class="robotoMedium">
    <li style="padding-bottom: 15px">
      <p translate>
        On the homepage, the menu is always visible on the left side of the screen. On other pages, the menu can be accessed by selecting the menu icon in the upper left corner of the screen:
      </p>
      <div>
        <img src="./assets/images/menuHelp.png" style="width: 100%;"/>
      </div>
    </li>
    <li>
      <p translate>
        You may choose what information is shown on the Home page by using the Settings panel, accessed by selecting the Settings button in the upper right corner of the screen:
      </p>
      <img src="./assets/images/settingsHelp.png" style="width: 28%;"/>
    </li>
  </ol>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>
